import { useState, useEffect } from "react"

import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"
import { message, Modal, Button, Input, Icon, Row, Col } from "antd"
import $api from "@/api"

let timer
function BannerForm({ name, title, stitle, classname = "" }) {
  const classnames = classModuleGenerator(styles)

  // const [realName, setRealName] = useState("")
  // const [phone, setPhone] = useState("")
  // const [vcode, setVcode] = useState("")
  // const [wenli, setWenli] = useState("")
  // const [score, setScore] = useState("")

  const [form, setForm] = useState({})
  const setFieldValue = (fieldName, value = "") => {
    setForm({
      ...form,
      [fieldName]: value,
    }) //等价于 Object.assign({...form},{fieldName:value})
  }

  const [sendBtnDisabled, setSendBtnDisabled] = useState(false)
  const [sendBtnValue, setSendBtnValue] = useState("发送验证码")
  const [countdown, setCountDown] = useState(60)
  const [visible, setVisible] = useState(false)

  const verification = async () => {
    const phonereg =
      /^1(3[0-9]|47|5((?!4)[0-9])|6(2|5|6)|7((?!4)[0-8])|8[0-9]|9(1|5|8|9))\d{8}$/ //手机号码正则验证
    if (!form.name) {
      return message.error("请输入姓名")
    }
    if (!phonereg.test(form.phone)) return message.error("请输入正确的手机号码")

    if (!form.wenli) {
      return message.error("请输入文/理科")
    }
    if (!form.score) {
      return message.error("请输入分数")
    }
    if (countdown === 60) tencentCaptcha()
    else setVisible(true)
  }

  useEffect(() => {
    if (countdown > 0 && countdown < 60) {
      setSendBtnValue(`${countdown}s`)
    } else {
      clearInterval(timer)
      setSendBtnDisabled(false)
      setCountDown(60)
      setSendBtnValue("发送验证码")
    }
  }, [countdown])
  const sendVcode = async ({ ticket, randstr }) => {
    const { result } = await $api.captcha.send({
      account: form.phone,
      ticket,
      randstr,
    })
    if (!result._id) {
      message.error(result.message || "验证码发送失败")
    }
    setFieldValue("vcode")
    timer = setInterval(() => {
      setCountDown((c) => --c)
    }, 1000)
    setVisible(true)
  }
  const tencentCaptcha = () => {
    setSendBtnDisabled(true)
    const captcha = new window.TencentCaptcha("2030433147", function (res) {
      if (res.ticket) sendVcode(res)
      else setSendBtnDisabled(false)
    })
    captcha.show()
  }
  const handleSave = async () => {
    const { result } = await $api.form.submit(form)
    if (result.code) message.error(result.message || "保存失败")
    else {
      setFieldValue("vcode")
      setVisible(false)
      Modal.success({
        title: "领取成功",
        content: "我们的老师会尽快与您联系",
        okText: "我知道了",
        maskClosable: true,
      })
    }
  }
  useEffect(() => {
    return () => clearInterval(timer)
  }, [])

  return (
    <div className={classnames("banner-form-wrap", classname)}>
      <Modal
        visible={visible}
        onOk={handleSave}
        onCancel={() => setVisible(false)}
        okText="确认"
        cancelText="取消"
        bodyStyle={{ padding: "32px 32px 24px" }}
        width={416}
      >
        <Row className={classnames("vcode-modal")}>
          <Col span={2}>
            <Icon type="mail" style={{ color: "#faad14" }} />
          </Col>
          <Col span={22}>
            <h4>我们向您填写的电话发送了短信验证码</h4>
          </Col>
          <Col span={2}></Col>
          <Col span={15}>
            <Input
              placeholder="请输入验证码"
              maxLength={6}
              onChange={(e) => setFieldValue("vcode", e.target.value)}
            />
          </Col>
          <Col span={7}>
            <Button
              type="link"
              disabled={sendBtnDisabled}
              onClick={verification}
            >
              {sendBtnValue}
            </Button>
          </Col>
        </Row>
      </Modal>
      <div className={classnames("banner-form-left")}>
        <h2>{title}</h2>
        <h4>{stitle}</h4>
        <button
          onClick={() => {
            window.openJesongChatByGroup(121, 52601)
            return false
          }}
        >
          立即咨询
        </button>
      </div>
      <div className={classnames("banner-form-right")}>
        <h3>{name || "免费获取定制版学情报告"}</h3>
        <ul>
          <li>
            <label htmlFor="realName">姓名：</label>
            <input
              id="realName"
              type="text"
              value={form.name || ""}
              onChange={(e) => setFieldValue("name", e.target.value)}
              autoComplete="off"
            />
          </li>
          <li>
            <label htmlFor="phone">电话：</label>
            <input
              id="phone"
              type="text"
              value={form.phone || ""}
              onChange={(e) => setFieldValue("phone", e.target.value)}
              autoComplete="off"
            />
          </li>
          <li>
            <label htmlFor="wenli">文/理科：</label>
            <input
              id="wenli"
              type="text"
              value={form.wenli || ""}
              onChange={(e) => setFieldValue("wenli", e.target.value)}
              autoComplete="off"
            />
          </li>
          <li>
            <label htmlFor="score">分数：</label>
            <input
              id="score"
              type="text"
              value={form.score || ""}
              onChange={(e) => setFieldValue("score", e.target.value)}
              autoComplete="off"
            />
          </li>
        </ul>
        <button className={classnames("receive-btn")} onClick={verification}>
          立即领取
        </button>
      </div>
    </div>
  )
}

export default BannerForm
